import initVueApp from "@/core.js";
const component = require(`./../views/MidGridFeaturedCollection.vue`).default;
initVueApp(component);
